import React, { Component } from 'react';
import ReactLoading from 'react-loading';
import { toast } from 'react-toastify';
import swal from '@sweetalert/with-react';
import PropTypes from 'prop-types';
import TechnicalReportForm from './form';
import API from '../../services/api';
import { Wrapper, Container, Content } from '../../css/styles/wrapper';
import TechnicalReportList from './technicalReportList';
import TechnicalReportFilterForm from './technicalReportFilterForm';

class TechnicalReportContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      technicalReport: null,
      technicalReports: [],
      employees: [],
      equipments: [],
      loading: false,
      closedList: false,
      activeOsButton: true,
      listClosed: true,
    };
    this.handleEmployeesList = this.handleEmployeesList.bind(this);
    this.handleEquipmentsList = this.handleEquipmentsList.bind(this);
    this.getList = this.getList.bind(this);
    this.handleCreation = this.handleCreation.bind(this);
    this.getList();
    this.handleEdit = this.handleEdit.bind(this);
    this.handleNew = this.handleNew.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  refTechnicalReport = React.createRef();

  scrollToMyRef = myRef => {
    window.scrollTo(0, myRef.current.offsetTop);
  };

  toggleListClosed = () => {
    this.setState(
      prevState => ({ listClosed: !prevState.listClosed }),
      () => this.getList()
    );
  };

  getList = async value => {
    const employeeUuid = value?.employee_uuid || null;
    const equipmentUuid = value?.equipment_uuid || null;
    this.handleEmployeesList();
    this.handleEquipmentsList();
    this.setState({ loading: true });
    try {
      const response = await API.get('/technicalreports', {
        params: {
          employeeUuid: employeeUuid,
          equipmentUuid: equipmentUuid,
          withoutMaintenanceTechnicalReport: this.state.listClosed,
        },
      });

      this.setState({ technicalReports: response.data, loading: false });
    } catch (err) {
      console.error(err);
      toast.error('Um erro aconteceu durante o carregamento.');
      this.setState({ loading: false });
    }
  };

  handleEquipmentsList = async () => {
    try {
      const response = await API.get('/equipments');
      this.setState({ equipments: response.data });
    } catch (err) {
      toast.error('Um erro aconteceu durante o carregamentos!');
    }
  };

  handleEmployeesList = async () => {
    try {
      const response = await API.get('/employees');
      this.setState({ employees: response.data });
    } catch (err) {
      toast.error('Um erro aconteceu durante o carregamentos!');
    }
  };

  handleCreation = async technicalReport => {
    const data = {
      description: technicalReport.description.toUpperCase(),
      employeeUuid: technicalReport?.employee?.uuid,
      equipmentUuid: technicalReport?.equipment?.uuid,
    };

    try {
      const response = await API.post('/technicalreports', { ...data });
      await this.getList();
      this.handleNew();
      console.log({ ...data });
      toast.success('Manutenção criada com sucesso!');
    } catch (err) {
      toast.error('Um erro aconteceu durante o cadastro!');
    }
  };
  handleTechnicalReportGet = async uuid => {
    try {
      const response = await API.get(`/technicalreports/${uuid}`);
      this.setState({
        technicalReport: response?.data,
      });
      console.log(response?.data);
      return response?.data;
    } catch (err) {
      toast.error('Um erro aconteceu durante o carregamento!');
      console.error('erro: ->', err);
    }
  };

  handleEdit = async object => {
    this.setState({
      equipment: object?.equipment,
      employee: object?.employee,
      description: object?.description,
    });
    const response = await this.handleTechnicalReportGet(object.uuid);

    if (response?.maintenancetechnicalreports?.length === 0) {
      this.setState({ activeOsButton: false });
    } else {
      this.setState({ activeOsButton: true });
    }
  };

  handleUpdate = async object => {
    const { technicalReport } = this.state;
    console.log('update -> :', technicalReport);

    try {
      const response = await API.put(
        `/technicalreports/${technicalReport?.uuid}`,
        {
          employeeUuid: object?.employee?.uuid,
          equipmentUuid: object?.equipment?.uuid,
          description: object?.description?.toUpperCase(),
        }
      );
      this.handleEquipmentsList();
      this.handleEmployeesList();
      console.log('data: ->:', response.data?.updatedValues);
      if (response.data?.updatedValues?.uuid) {
        this.handleEdit(response.data?.updatedValues);
      } else {
        console.warn('error ao att', response.data);
      }
      await this.getList();
      this.handleNew();
      toast.success('Relatório técnico atualizado com sucesso!');
    } catch (err) {
      console.error('error: -> ', err);
      toast.error('Um erro aconteceu durante a atualização!');
    }
  };

  handleNew = () => {
    this.setState({
      technicalReport: null,
      equipment: null,
      employee: null,
      description: '',
    });
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  };

  handleDelete = async uuid => {
    const { technicalReport } = this.state;

    try {
      const confirmDelete = await swal({
        dangerMode: true,
        text: 'Confirma a exclusão do relatório técnico?',
        buttons: {
          cancel: 'Não',
          confirm: 'Sim',
        },
      });

      console.log('RP for delete -> :', uuid);
      if (confirmDelete) {
        await API.delete(`technicalreports/${uuid}`);
        console.log('reporte tecnico deletado', uuid);
        await this.getList();
        console.log('listagem atualizada após exclusão.');
        this.handleNew();
        console.log('resetando após exclusão');
        toast.success('Relatório técnico deletado com sucesso!');
      }
    } catch (err) {
      console.error('erro ao excluir', err);
      toast.error('Um erro aconteceu durante a exclusão!');
    }
  };

  render() {
    const {
      technicalReport,
      technicalReports,
      loading,
      employees,
      employee,
      equipments,
      equipment,
      activeOsButton,
      listClosed,
    } = this.state;
    return (
      <Wrapper>
        <Container>
          <header>
            <h1>RELATÓRIOS TÉCNICOS</h1>
            <div className="buttons-container">
              <button type="button" onClick={this.handleNew}>
                NOVO
              </button>
              <button type="button" onClick={this.toggleListClosed}>
                {listClosed ? 'TODOS' : 'ABERTOS'}
              </button>
            </div>
          </header>
          <TechnicalReportFilterForm
            onList={this.getList}
            equipments={equipments}
            employees={employees}
          />
          <TechnicalReportList
            technicalReports={technicalReports}
            loading={loading}
            onEdit={this.handleEdit}
            onDelete={this.handleDelete}
          />
          <TechnicalReportForm
            activeOsButton={activeOsButton}
            onCreation={this.handleCreation}
            onEdit={this.handleEdit}
            onUpdate={this.handleUpdate}
            onNew={this.handleNew}
            onDelete={this.handleDelete}
            technicalReport={technicalReport}
            technicalReports={technicalReports}
            equipment={equipment}
            equipments={equipments}
            employee={employee}
            employees={employees}
            description={this.state.description}
          />
        </Container>
      </Wrapper>
    );
  }
}

TechnicalReportContainer.propTypes = {
  // technicalReportForm: PropTypes.bool.isRequired,
  // onTechnicalreportsList: PropTypes.func.isRequired,
  // onTechnicalReportSubmit: PropTypes.func.isRequired,
};

export default TechnicalReportContainer;

